/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { Container, injectable } from 'inversify';
import { vappContainer } from './index';
import { EventBusModule } from '@common/event-bus-module';
import { JwtModule } from '@common/jwt-module';

export class UnitTest {
  constructor() {}

  async run() {
    await this.eventBusTest();
    // await this.jwtTest();
  }

  async eventBusTest() {
    //------------->>>>>--------------//
    const ebModule = vappContainer.get<EventBusModule>(EventBusModule.name);
    const eb = ebModule?.getEventBus();
    eb.on('test-event', function (payload: any) {
      console.log('event received', payload);
    });
    eb.emit('test-event', null, {
      message: 'Hello From vlinder unit test',
    });
    //------------->>>>>--------------//
  }

  async dummyGraphQlQuery() {
    //------------->>>>>--------------//
    //------------->>>>>--------------//
  }
}
